import { assignApplicationOwner } from 'commons/service/bank/application'
import { AssignOwnerRequest } from 'commons/types/DTO/bank/applications/manage/AssignOwnerRequest'
import { WriteHook, useMutationManager } from 'state-manager'

export const useAssignApplicationOwner: WriteHook<AssignOwnerRequest, void> = (opts) =>
  useMutationManager<AssignOwnerRequest, void>(assignApplicationOwner, opts)
